module.exports = __webpack_public_path__ + "static/img/android1.2.7cf146ad.jpg";